import styled, { css } from 'styled-components';

const variantStyles = {
  urgent: css`
    background: ${({ theme }) => theme.colors.status.urgent};
    color: white;
  `,
  inProgress: css`
    background: ${({ theme }) => theme.colors.status.inProgress};
    color: white;
  `,
  completed: css`
    background: ${({ theme }) => theme.colors.status.completed};
    color: white;
  `,
  notSubmitted: css`
    background: ${({ theme }) => theme.colors.status.notSubmitted};
    color: white;
  `,
  teacher: css`
    background: ${({ theme }) => theme.colors.role.teacher};
    color: white;
  `,
  student: css`
    background: ${({ theme }) => theme.colors.role.student};
    color: white;
  `,
  assistant: css`
    background: ${({ theme }) => theme.colors.role.assistant};
    color: white;
  `,
  parent: css`
    background: ${({ theme }) => theme.colors.role.parent};
    color: white;
  `,
  subject: css`
    background: ${({ theme }) => theme.colors.primaryLight};
    color: ${({ theme }) => theme.colors.primaryDark};
  `,
  subjectGreen: css`
    background: ${({ theme }) => theme.colors.accent.greenLight};
    color: #15803D;
  `,
  subjectPurple: css`
    background: ${({ theme }) => theme.colors.accent.purpleLight};
    color: #7B1FA2;
  `,
  notice: css`
    background: ${({ theme }) => theme.colors.accent.redLight};
    color: ${({ theme }) => theme.colors.accent.red};
  `,
};

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
  ${({ $variant }) => variantStyles[$variant] || variantStyles.subject}
`;

export default Badge;
